import { ProviderServiceODataRepo, ProviderServiceRepo } from "../../data/repo";
import { ProviderServiceModel } from "../../data/entities";
import { ProviderAddAllServicesRequest } from "../../models";
import { BaseEntityService } from "../BaseEntityService"

export class ProviderServiceService extends BaseEntityService<ProviderServiceModel, ProviderServiceRepo, ProviderServiceODataRepo> {
  constructor(){
    super(new ProviderServiceRepo(), new ProviderServiceODataRepo());
  }
  async insertAllServiceTypeServices(request: ProviderAddAllServicesRequest): Promise<boolean> {
    return await this.repo.insertAllServiceTypeServices(request);
  }
  async getServicesByProviderId(providerId: number): Promise<ProviderServiceModel[]>{
    return await this.repo.getServicesByProviderId(providerId);
  }
}

export default ProviderServiceService;
